document.addEventListener('DOMContentLoaded', function () {
  var appsScriptUrl = 'https://script.google.com/macros/s/AKfycbyhFgpOf99sthhXoPCI5sFBBd9aPnfqc5wnaLOAljb0lIiNn1Kgczz8VBD4pyi2ZgAZ/exec';

  document.querySelectorAll('.yf-mayoristas a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (event) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  var form = document.querySelector('.yf-mayoristas form');
  if (!form) return;

  var alreadySubmitting = false;

  form.addEventListener('submit', function (event) {
    if (alreadySubmitting) return;

    event.preventDefault();

    var button = form.querySelector('.yf-submit-btn');
    if (button) {
      var span = button.querySelector('span');
      if (span) span.textContent = 'Enviando...';
      button.classList.add('is-loading');
      button.disabled = true;
    }

    var formData = new FormData(form);
    var payload = new URLSearchParams();

    payload.append('nombre', formData.get('contact[Nombre completo]') || '');
    payload.append('ciudad', formData.get('contact[Ciudad]') || '');
    payload.append('email', formData.get('contact[email]') || '');
    payload.append('telefono', formData.get('contact[WhatsApp]') || '');
    payload.append('tienda', formData.get('contact[Tienda física]') || '');
    payload.append('pares', formData.get('contact[Pares al mes]') || '');
    payload.append('vende', formData.get('contact[Dónde vendes actualmente]') || '');
    payload.append('mensaje', formData.get('contact[body]') || '');
    payload.append('url', window.location.href);

    fetch(appsScriptUrl, {
      method: 'POST',
      body: payload,
      mode: 'no-cors',
      keepalive: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
      .catch(function (error) {
        console.log('No se pudo enviar a Google Sheets:', error);
      })
      .finally(function () {
        alreadySubmitting = true;
        form.submit();
      });
  });
});
